<template>
  <!-- 头部 -->
  <div class="des-header clearfix">
    <!-- 左侧 -->
    <div class="des-header-left clearfix">
      <img class="des-logo" src="../../../assets/images/logo.png" />
      <div class="des-nav">
        <el-menu
          class="el-menu-demo"
          mode="horizontal"
        >
          <el-menu-item index="a"><a :href="jumpToHomeJudge">首页</a></el-menu-item>
          <el-submenu v-for="(item,index) in menus" :key="item.title" :index="index+''">
            <template slot="title">{{item.title}}</template>
            <el-menu-item
              v-for="(itemChild,idx) in item.modules"
              :index="index+'-'+idx" :key="itemChild.name"
            ><a :href="itemChild.href">{{itemChild.name}}</a></el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
    <!-- 右侧 -->
    <div class="des-header-right">
      <ul>
        <li class="des-admininfo">
          <img src="../../../assets/images/user.png" />
          <p v-if='this.inner'>{{ currentUserData.name}}</p>
          <p v-else >{{currentUserData}}</p>
        </li>
        <li class="des-index-icon">
          <el-popover
            placement="top"
            width="160"
            v-model="visible">
            <p>您确定要退出当前用户吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="visible = false">取消</el-button>
              <el-button type="primary" size="mini" @click="loginout">确定</el-button>
            </div>
            <img slot="reference" src="../../../assets/images/close.png"/>
          </el-popover>
        </li>
      </ul>
    </div>
    <!--  -->
    <div class="index-top-download" style="" v-if="showHTML">
        <a :href= 'downloadExcelUrl' download="">操作手册</a>
    </div>
    <div class="index-top-download" style="">
        <a @click="upPasswordDialog=true">修改密码</a>
    </div>
    <div >
      <el-dialog title="修改密码" :visible.sync="upPasswordDialog" :close-on-click-modal="false" width="400px">
        <el-form  label-width="130px" style="text-align: left;"  :inline="true"  class="demo-form-inline">
            <el-form-item label="原密码" required="" style="margin-bottom: 0">
                <el-input size="mini" placeholder="请输入原密码" v-model="oldPassword" type ="password" auto-complete="new-password" style="margin-right: 0;" ></el-input>
            </el-form-item>
            <el-form-item label="新密码" required="" style="margin-bottom: 0">
                <el-input size="mini" placeholder="请输入新密码" v-model="newPassword" type ="password" auto-complete="new-password" style="margin-right: 0;" ></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" required="" style="margin-bottom: 0">
                <el-input size="mini" placeholder="请再次输入新密码" v-model="repeatPassword" type ="password" auto-complete="new-password" style="margin-right: 0;" ></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" style=" float: left; width: 100%; padding: 10px 0; margin: 0 auto; background: #e5e5e5; text-align: center;">
            <el-button style="font-size: 12px" @click="upPassword()"  type="primary" ><i class="el-icon-circle-check" style="margin-right: 5px"></i>修 改</el-button>
            <el-button style="font-size: 12px" @click="closeUpDialog()" ><i class="el-icon-circle-close" style="margin-right: 5px"></i>取 消</el-button>
        </div>
      </el-dialog>
     </div>
  </div>
</template>

<script>
import ngConfig from "@/config"
import { getToken,removeToken} from '@/utils/auth'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import {updatePassword} from '../../../modules/sys/api/users';
import { setStore, getStore, removeStore } from '@/utils/store'
export default {
  name: 'BioNavbar',
  data(){
    return {
      visible: false,
      currentUserData:'',
      downloadExcelUrl:'',
      showHTML:'',
      upPasswordDialog:false,
      repeatPassword:'',
      oldPassword:'',
      newPassword:'',
      inner:true,
      catchData: {}
    }
  },
  computed:{
    ...mapGetters(['userData','menus']),
    jumpToHomeJudge(){
      let noJumpPath = ['/user','/supplier']
      var type = getToken('type')
      console.log(type)
      if(type == '2' || type =='4'){
        return noJumpPath.indexOf(this.$route.path)!=-1 ? 'javascript:void(0)' : ngConfig.desktopSupplierNav
      }else{
        return noJumpPath.indexOf(this.$route.path)!=-1 ? 'javascript:void(0)' : ngConfig.desktopNav
      }
      console.log( this.$route.path)
    }
  },
  mounted(){
    let userData = this.userData;
    //console.log(userData)
    if(userData!='' && typeof userData == 'string'){
      this.currentUserData = JSON.parse(userData)
    }else if(userData  == null){
      this.inner =false
      this.currentUserData = getToken('name')
    }
    else{
      this.currentUserData = userData
    }
    this.getCookie()
  },
  methods:  {
    ...mapActions(['LoginOut']),
    ...mapMutations(['SET_MENUS']),
    formatStorageName(name){
      let keyname = 'user_';
      return keyname += name;
    },
    formatStorageName2(name){
      let keyname = 'user2_';
      return keyname += name;
    },
    beforeClear(){
      let status = window.localStorage.getItem(this.formatStorageName('checked'))
      let status2 = window.localStorage.getItem(this.formatStorageName2('checked'))
      let username = window.localStorage.getItem(this.formatStorageName('username'))
      let username2 = window.localStorage.getItem(this.formatStorageName2('username'))
      let password = window.localStorage.getItem(this.formatStorageName('password'))
      let password2 = window.localStorage.getItem(this.formatStorageName2('password'))
      this.catchData = {status, status2, username, username2, password, password2};
    },
    afterClear(){
      let {status, status2, username, username2, password, password2} = this.catchData
      window.localStorage.setItem(this.formatStorageName('checked'), status)
      window.localStorage.setItem(this.formatStorageName2('checked'), status2)
      window.localStorage.setItem(this.formatStorageName('username'), username)
      window.localStorage.setItem(this.formatStorageName2('username'), username2)
      window.localStorage.setItem(this.formatStorageName('password'), password)
      window.localStorage.setItem(this.formatStorageName2('password'), password2)
    },
    loginout() {
      this.beforeClear();
      this.LoginOut().then(() => {
        this.visible = false;
        removeToken('msid')
        removeToken('name')
        removeToken('nick')
        removeToken('type')
        removeToken('supplierId')

//alert(ngConfig.system)
var storage = window.localStorage;

      console.log(storage)
      storage.clear()
      window.sessionStorage.clear();
      //alert(storage)
        removeStore(ngConfig.system);
        this.afterClear(); //
        window.location.href = ngConfig.login;
        window.location.reload()
      })
    },
    showChildNav(){
      this.ifShowChildNav = true;
    },
    hideChildNav(){
      this.ifShowChildNav = false;
    },
    // 是否为桌面
    getCookie(){
      var url = window.location.href;
      var host = window.location.host;
      //var system = window.location.href;
      if(url.indexOf("desktop") != -1){
        this.showHTML = true
        var type = getToken('type')
        if(type == '1' || type =='3'){
          this.downloadExcelUrl = 'http://'+ host + '/srm-sys-server/api/common/file/downloadOperationManual?templateName=sys_user'
        }else{
          this.downloadExcelUrl = 'http://'+ host + '/srm-sys-server/api/common/file/downloadOperationManual?templateName=sys_supplier'
        }

      }else{
        this.showHTML = false;
      }
    },
    // 修改密码
    upPassword(){
        if(!this.oldPassword){
          this.$message.error("原密码不能为空!")
          return
        }
        if(!this.newPassword){
          this.$message.error("新密码不能为空!")
          return
        }
        if(!this.repeatPassword){
          this.$message.error("再次输入的新密码不能为空!")
          return
        }
        if(this.newPassword!=this.repeatPassword){
          this.$message.error("两次输入的密码不一致!")
          return
        }
        updatePassword(this.oldPassword,this.newPassword).then(res=>{
            if(res.errorCode='200'){
              this.$message.success(res.msg)
            }else{
               this.$message.error(res.msg)
            }
            this.clearUpPassword()
            this.upPasswordDialog=false
        })
    },
    closeUpDialog(){
      this.upPasswordDialog=false;
      this.clearUpPassword();
    },
    clearUpPassword(){
      this.repeatPassword='';
      this.oldPassword='';
      this.newPassword='';
    },
  }
}
</script>
<style>
.index-top-download{
  float: right;
  height: 50px;
}
.el-dialog__footer{
  padding: 10px 0px !important;
}
.el-dialog__header {
  padding: 20px 20px 10px;
  background-color: #005fa7;
  color: #fff;
}
.el-dialog__title{
  color: #fff;
}
.index-top-download a{ color: #fff; font-size: 12px;display: block;
    height: 50px;
    line-height: 50px; margin-right: 15px}

</style>



// WEBPACK FOOTER //
// src/components/layout/components/Navbar.vue